import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-list-group',
  templateUrl: './ui-list-group.component.html',
  styleUrls: ['./ui-list-group.component.scss']
})
export class UiListGroupComponent implements OnInit {
  homeTab: boolean = true;
  profileTab: boolean;
  settingTab: boolean;
  messagesTab: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  onMenuTab(number) {
    this.homeTab = false;
    this.profileTab = false;
    this.messagesTab = false;
    this.settingTab = false;
    if (number == '1') {
      this.homeTab = true;
    }
    else if (number == '2') {
      this.profileTab = true;
    }
    else if (number == '3') {
      this.messagesTab = true;
    }
    else if (number == '4') {
      this.settingTab = true;
    }
  }
}
